import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElProgram, ElProgramContent, ElColumn, elGapProgram, elBgWhite } from "./program.css";
import { Container } from "../../layout";
import { Link } from "react-router-dom";
import { ElHeadLine } from "../head-title";
import { elAnchorButton, elAnchorButtonWhite, ElColumnSubs } from "../banner";

interface IProgramProps extends HTMLAttributes<HTMLElement> {}

export const Program: FC<IProgramProps> = ({ children, ...props }) => {
  return (
    <ElProgram {...props} id="program">
      <Container className={elGapProgram}>
        <ElProgramContent>
          <ElHeadLine style={{ maxWidth: "350" }}>Our Program</ElHeadLine>
        </ElProgramContent>
        <ElProgramContent>
          <ElColumn className={elBgWhite}>
            <img src={Images.design.create} alt="" />
            <h3>
              <span>BEKUP</span> <span data-color="green">Create</span>
            </h3>
            <p>
              Melalui pelatihan dan mentoring intensif untuk untuk startup post-MVP, memperkuat model bisnis, traksi pasar, dan stabilitas keuangan guna menarik investasi pre-series A.
              {/* <Link to={"/program-bekup-create"}>selengkapnya..</Link> */}
            </p>
            <ElColumnSubs>
              <Link to={"/program-bekup-create"} className={elAnchorButton}>
                Explore Program
              </Link>
              <Link to={"https://dicoding.id/bekup-reg"} target="_blank" className={elAnchorButtonWhite}>
                Daftar Sekarang
              </Link>
            </ElColumnSubs>
          </ElColumn>
          <ElColumn className={elBgWhite}>
            <img src={Images.design.acelerate} alt="" />
            <h3>
              <span>BEKUP</span> <span data-color="green">ACCELERATE</span>
            </h3>
            <p>
              Melalui workshop kreatif, pelatihan teknologi (coding, UI/UX), mentoring, dan proyek praktis, peserta dibimbing dari ideasi hingga menciptakan prototipe/MVP aplikasi digital.
              {/* <Link to={"/program-bekup-accelerate"}>selengkapnya..</Link> */}
            </p>
            <ElColumnSubs>
              <Link to={"/program-bekup-accelerate"} className={elAnchorButton}>
                Explore Program
              </Link>
              <Link to={"https://s.id/Reg-BEKUP-Growth"} target="_blank" className={elAnchorButtonWhite}>
                Daftar Sekarang
              </Link>
            </ElColumnSubs>
          </ElColumn>
        </ElProgramContent>
      </Container>
    </ElProgram>
  );
};
